import React from 'react';
import PropTypes from 'prop-types';
import { get, find } from 'lodash';
import { Container, Row, Col } from 'reactstrap';

import { Button } from '@skunexus/component-catalog';

import ResolvePurchaseOrder from '../ResolvePurchaseOrder';

import { PURCHASE_ORDER_STATUSES, PURCHASE_ORDER_REPUSH_OPTIONS } from '../../core/constants';

import styles from './styles.module.css';

function Module({ details, statuses, repushOrder }) {
    const orderState = get(find(statuses, ['state', get(details, 'state')]), 'state', '');

    const handleRepushOrder = () => {
        repushOrder({ id: details.id });
    };

    if (orderState && orderState === PURCHASE_ORDER_STATUSES.ERROR) {
        return (
            <Col xs="12" sm="auto">
                <Container className={`p-4 ${styles.resendWrapper}`}>
                    <Row>
                        <Col className="font-weight-bold">Retry Intervals:</Col>
                    </Row>

                    {PURCHASE_ORDER_REPUSH_OPTIONS.map((option, index) => (
                        <Row key={index}>
                            <Col xs="auto" className="font-italic">
                                {`Step ${index + 1}`}:
                            </Col>
                            <Col>{option}</Col>
                        </Row>
                    ))}

                    <Row className="mt-2">
                        <Col>
                            <Button color="primary" size="sm" onClick={handleRepushOrder}>
                                Resend Purchase Order
                            </Button>
                        </Col>
                    </Row>
                    <ResolvePurchaseOrder />
                </Container>
            </Col>
        );
    }

    return null;
}

Module.propTypes = {
    details: PropTypes.object.isRequired,
    statuses: PropTypes.array.isRequired,
    repushOrder: PropTypes.func.isRequired,
};

export default Module;
